<template>
  <div class="page-container dashboard-page">
    <div class="page-header">
      <LoadingOverlay :visible="loading || searchLoading" :message="searchLoading ? 'جارٍ البحث...' : loadingMessage" />
      <div class="left-actions">
        <UserBadge />
      </div>
      <div class="right-actions">
        <button class="logout-btn" @click="openLogout">تسجيل الخروج</button>
      </div>
    </div>

    <div class="content">
      <DashboardCards />
    </div>

    <transition name="">
      <div v-if="showLogoutModal" class="logout-modal-backdrop" @click.self="cancelLogout">
        <div class="logout-modal">
          <h3>تأكيد تسجيل الخروج</h3>
          <p>هل تريد بالفعل تسجيل الخروج؟ </p>
          <div class="logout-actions">
            <button class="btn-cancel" @click="cancelLogout">إلغاء</button>
            <button class="btn-confirm" @click="confirmLogout">تسجيل الخروج</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DashboardCards from '../components/DashboardCards.vue'
import UserBadge from '../components/UserBadge.vue'
import axios from 'axios'
import LoadingOverlay from '../components/LoadingOverlay1.vue'

export default {
  name: 'DashboardView',
  components: {
    DashboardCards,
    UserBadge,
    LoadingOverlay
  },
  data() {
    return {
      showLogoutModal: false,
      loading:false,
      searchLoading: false,
      loadingMessage:''
    }
  },
  created(){
    localStorage.setItem("CurrentPage","Dashboard");
  },
  methods: {
    openLogout() {
      this.showLogoutModal = true
    },
    cancelLogout() {
      this.showLogoutModal = false
    },
    async confirmLogout() {
      this.loading = true;
      var ip = localStorage.getItem("ip");
      var ip2 = localStorage.getItem("ip2");
      var bcloud = localStorage.getItem("BCloud");
      var str = 'method%3DWEB_Logout%26username%3D' + localStorage.getItem("username") + '%26password%3D' + localStorage.getItem('password') + '%26android_id%3D' + '' + '%26db_guid%3D' + localStorage.getItem('db_guid');
      var responseData = await this.post_request(str, ip);
      setTimeout(() => {
        this.loading = false
      }, 800);
      if (responseData.data[0]['State'] == false) {
        this.loading = false;
        this.loadingMessage = responseData.data[0]['Response'];
        return;
      }
      this.loadingMessage = 'تم تسجيل الخروج بنجاح';
      localStorage.clear();
      localStorage.setItem("ip", ip);
      localStorage.setItem("BCloud", bcloud);
      localStorage.setItem("ip2", ip2);
      this.$router.push({ name: "login" });      
    },
    async post_request(url, ip) {
      try {
        let result = '';
        if((localStorage.getItem('username2') == null || localStorage.getItem('username2') == '') && (localStorage.getItem('password2') == null || localStorage.getItem('password2') == '')){        
          return;        
        }        
        if(localStorage.getItem('BCloud') == 'true'){
            url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") ;
            url = {Username:localStorage.getItem("username2"), Password:localStorage.getItem("password2"),url:url,SESSION:localStorage.getItem("session")};
            ip = localStorage.getItem('ip');
        }else{
          url += "%26usernameSubscribe%3D" + localStorage.getItem("username2") + "%26passwordSubscribe%3D" + localStorage.getItem("password2") +'%26SESSION%3D' +localStorage.getItem("session") + '%26Ip%3D' +localStorage.getItem("session")   ;
          ip = localStorage.getItem('ip2');
        }
        let response = () => {          
          return new Promise(function (resolve) {
            axios.post( ip , url,
              {
                'Content-type': 'plain/text'
              }).then(response => {
                resolve(response);
              }).catch(async () => {
                resolve('Error')
              });
          });
        };
        result = await response();
        return result;
      } catch {
        return 'Error';
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions { display:flex; align-items:center; gap:12px }
.right-actions { display:flex; align-items:center }

.logout-btn {
  background: #ff4757;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(102,126,234,0.18);
}

.logout-btn:hover { transform: translateY(-2px); }

.page-container {
  min-height: 100vh;
  padding: 30px 20px;
  background: var(--primary-gradient);
  direction: rtl;
}

.content {
  max-width: 1000px;
  margin: 0 auto;
}

/* modal styles (matching InventoryPage) */
.logout-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.logout-modal {
  background: white;
  border-radius: 12px;
  padding: 22px;
  width: 360px;
  max-width: 92%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
  text-align: right;
}

.logout-modal h3 { margin: 0 0 10px 0; color: #2c3e50; }
.logout-modal p { color: #7f8c8d; margin-bottom: 18px; }
.logout-actions { display: flex; gap: 10px; justify-content: flex-end; }
.btn-cancel { background: #ecf0f1; border: none; padding: 8px 14px; border-radius: 8px; cursor: pointer; }
.btn-confirm { background: #ff4757; color: white; border: none; padding: 8px 14px; border-radius: 8px; cursor: pointer; }

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .left-actions, .right-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .logout-btn { padding: 8px 10px; font-size: 14px; }
  .user-badge .avatar { width:32px; height:32px; }
  .user-badge .info .name { font-size:13px }

  .logout-modal { width: 320px; padding: 18px }
}

@media (max-width: 420px) {
  .page-header { gap: 8px }
  .left-actions { justify-content: flex-start }
  .right-actions { justify-content: flex-end }
  .logout-btn { width: 100%; border-radius: 10px }
  .left-actions, .right-actions { flex-direction: row }
  .logout-modal { width: calc(100% - 32px); margin: 0 16px }
}
</style>
